import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

import SideBar from "@/components/sidebar";
import LoadingPage from "@/components/ui/LoadingPage";
import Overlay from "@/components/ui/overlay";
import { MapProvider } from "@/context/MapProvider";
import { useAuth } from "@/hooks/auth/useAuth";
import { RootState } from "@/store";

const ProtectedRoute = () => {
  const { isAuthenticating, isAuthenticated, isAuthChecked, hasLoggedIn } =
    useAuth();

  const { showComparisonPopup, isDrawPolygon, showLoadingOverlay } =
    useSelector((state: RootState) => state.ui);
  const navigate = useNavigate();

  // Redirect to login if the user has never logged in,
  // or after the authentication check completes and the user is unauthenticated.
  // This prevents premature redirects while the initial auth query is still running.
  useEffect(() => {
    if (
      (!hasLoggedIn || isAuthChecked) &&
      !isAuthenticating &&
      !isAuthenticated
    ) {
      navigate("/login", {
        replace: true
      });
    }
  }, [navigate, isAuthenticated, isAuthenticating, isAuthChecked, hasLoggedIn]);

  // check the !isAuthenticated to wait the navigation to login page
  if (isAuthenticating || !isAuthenticated) {
    return <LoadingPage />;
  }

  return (
    <MapProvider>
      <div className="flex h-screen text-[12px]">
        {showLoadingOverlay && <Overlay />}
        {!showComparisonPopup.isShow && !isDrawPolygon && <SideBar />}
        <div className="flex flex-col flex-grow overflow-hidden">
          <Outlet />
        </div>
      </div>
    </MapProvider>
  );
};

export default ProtectedRoute;
